// extracted by mini-css-extract-plugin
module.exports = {"loader-dimer":"IndexPage_loader-dimer__xoW8x","loader-size":"IndexPage_loader-size__QrgnG","highlight-container":"IndexPage_highlight-container___aLK5"};